/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  global.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import Vue from 'vue'

/**
 * 这个功能是方便页面判断当前是否是编辑状态
 */
Object.defineProperty(Vue.prototype, '$isEdit', { get () { return this.$route.query.op === 'edit' } })
/**
 * 取id
 */
Object.defineProperty(Vue.prototype, '$id', { get () { return this.$route.query.id as string } })
